export class Lightbox {
  constructor() {
    document.querySelectorAll('[data-lightbox-gallery]').forEach((root) => this.#bind(root))
  }

  #bind(root) {
    const dialog = root.querySelector('[data-lightbox-dialog]')
    const img = dialog?.querySelector('[data-lightbox-img]')
    if (!dialog || !img) return

    root.querySelectorAll('[data-lightbox-src]').forEach((btn) => {
      btn.addEventListener('click', () => {
        img.src = btn.getAttribute('data-lightbox-src') || ''
        img.alt = btn.getAttribute('data-lightbox-alt') || ''
        dialog.showModal()
      })
    })

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close()
    })
  }
}
